<template>
  <canvas
    :id="id"
    :height="height"
    class="line-chart"/>
</template>

<script>
import Chart from 'chart.js'

/**
   * 'LineChart' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'LineChart',
  props: {
    height: {
      type: String,
      default: '300px'
    },
    labels: {
      type: Array,
      default () {
        return []
      }
    },
    datasets: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      id: this.generateId(),
      chart: null,
      ctx: null
    }
  },
  watch: {
    labels () {
      this.chart.data.labels = this.labels
      this.chart.update()
    },
    datasets () {
      this.chart.data.datasets = this.datasets
      this.chart.update()
    }
  },
  mounted () {
    this.chart = new Chart(this.id, {
      type: 'line',
      data: {
        labels: this.labels
      },
      datasets: this.datasets,
      options: {
        maintainAspectRatio: false,
        legend: {
          position: 'top',
          labels: {
            boxWidth: 15,
            fontColor: 'black',
            fontFamily: 'Open Sans',
            fontSize: 13,
            padding: 10
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              display: true
            },
            ticks: {
              fontColor: '#cdcdcd',
              beginAtZero: true,
              stepSize: 25
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              fontColor: '#cdcdcd'
            }
          }]
        }
      }
    }
    )
  },
  beforeDestroy () {
    this.chart.destroy()
  },
  methods: {
    generateId () {
      return '_' + Math.random().toString(36).substr(2, 9)
    }
  }
}
</script>

<style lang="scss" scoped>
  .line-chart {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/_shared/charts/line-chart.vue